<template>
  <div :style="{ backgroundColor: theme.screenBackgroundColor.value }" class="menu-screen">
    <header class="header" :style="{ backgroundColor: theme.headerBackgroundColor.value }">
      <h1 class="header-title" :style="{ color: theme.headerTextColor.value }">Menu</h1>
    </header>

    <div class="meta-section">
      <h2 :style="{ color: theme.PrimaryTextColor.value }">1st Pickup Location(Bar)</h2>
      <p :style="{ color: theme.SecondaryTextColor.value }">Come to the front for pickup</p>
      <div class="pill" :style="{ backgroundColor: theme.accentBackgroundColor.value, color: theme.accentTextColor.value }">
        Estimated Time: 2-4 Minutes
      </div>
    </div>

    <div class="category">
      <h2 class="category-title" :style="{color: theme.PrimaryTextColor.value,  borderTop: '2px solid ' + theme.borderColor.value}">Cocktails</h2>
      <div class="item-row" :style="{ borderBottom: '1px solid ' + theme.borderColor.value}">
        <div class="item-text">
          <h5 :style="{ color: theme.altTextHeaderColor.value }">Vodka Cranberry</h5>
          <p :style="{ color: theme.PrimaryTextColor.value }">$1.00</p>
          <p :style="{ color: theme.SecondaryTextColor.value }">A classic</p>
        </div>
        <img src="@/assets/vodka cranberry.jpg" class="item-img" />
      </div>

      <div class="item-row" :style="{ borderBottom: '1px solid ' + theme.borderColor.value}">
        <div class="item-text">
          <h5 :style="{ color: theme.altTextHeaderColor.value }">Margharita</h5>
          <p :style="{ color: theme.PrimaryTextColor.value }">$1.00</p>
          <p :style="{ color: theme.SecondaryTextColor.value }">A classic</p>
        </div>
        <img src="@/assets/Margharita.jpg" class="item-img" />
      </div>

      <div class="item-row">
        <div class="item-text">
          <h5 :style="{ color: theme.altTextHeaderColor.value }">Rum Punch</h5>
          <p :style="{ color: theme.PrimaryTextColor.value }">$1.00</p>
          <p :style="{ color: theme.SecondaryTextColor.value }"></p>
        </div>
      </div>
    </div>
    <div class="category">
      <h2 class="category-title" :style="{color: theme.PrimaryTextColor.value,  borderTop: '2px solid ' + theme.borderColor.value}">Wine</h2>
      <div class="item-row" :style="{ borderBottom: '1px solid ' + theme.borderColor.value}">
        <div class="item-text">
          <h5 :style="{ color: theme.altTextHeaderColor.value }">Red Wine</h5>
          <p :style="{ color: theme.PrimaryTextColor.value }">$1.00</p>
        </div>
        <img src="@/assets/vodka cranberry.jpg" class="item-img" />
      </div>
    </div>

    <div class="view-cart" :style="{ backgroundColor: theme.submitButtonColor.value, color: theme.submitButtonTextColor.value }">
      View Cart(1)
    </div>
  </div>
</template>


<script>
export default {
  name: 'MenuPreview',
  props: ['theme']
};
</script>

<style scoped>
.menu-screen {
  padding: 16px;
  min-height: 100vh;
}

.header {
  padding: 12px 16px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.header-title {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}

.meta-section {
  text-align: center;
  margin-bottom: 24px;
}

.pill {
  display: inline-block;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: bold;
  margin-top: 8px;
}

.category-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 12px;
  padding-top: 12px;
  margin-top: 24px;
}

.item-row {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  margin-bottom: 12px;
}

.item-text {
  flex: 1;
}

.item-img {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: cover;
  margin-left: 12px;
}

.view-cart {
  margin-top: 24px;
  text-align: center;
  padding: 14px;
  font-weight: bold;
  border-radius: 8px;
}
</style>
